import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDigitalCastSettingsMutationVariables = Types.Exact<{
  settings: Types.AccountsDigitalCastSettingsInput;
}>;


export type UpdateDigitalCastSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly updateDigitalCastSettings?: boolean | null };

export type VoteForStubLayerMutationVariables = Types.Exact<{
  layerId: Types.StubLayerId;
}>;


export type VoteForStubLayerMutationPage = { readonly __typename?: 'RootMutationType', readonly voteForStubLayer: { readonly __typename?: 'StubLayerVoteResult', readonly success: boolean, readonly totalVotes: number, readonly hasVoted: boolean } };


export const UpdateDigitalCastSettingsDocument = gql`
    mutation UpdateDigitalCastSettings($settings: AccountsDigitalCastSettingsInput!) {
  updateDigitalCastSettings(settings_input: $settings)
}
    `;
export type UpdateDigitalCastSettingsMutationFn = Apollo.MutationFunction<UpdateDigitalCastSettingsMutationPage, UpdateDigitalCastSettingsMutationVariables>;

/**
 * __useUpdateDigitalCastSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDigitalCastSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDigitalCastSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDigitalCastSettingsMutation, { data, loading, error }] = useUpdateDigitalCastSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateDigitalCastSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDigitalCastSettingsMutationPage, UpdateDigitalCastSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDigitalCastSettingsMutationPage, UpdateDigitalCastSettingsMutationVariables>(UpdateDigitalCastSettingsDocument, options);
      }
export type UpdateDigitalCastSettingsMutationHookResult = ReturnType<typeof useUpdateDigitalCastSettingsMutation>;
export type UpdateDigitalCastSettingsMutationResult = Apollo.MutationResult<UpdateDigitalCastSettingsMutationPage>;
export type UpdateDigitalCastSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDigitalCastSettingsMutationPage, UpdateDigitalCastSettingsMutationVariables>;
export const VoteForStubLayerDocument = gql`
    mutation VoteForStubLayer($layerId: StubLayerId!) {
  voteForStubLayer(layerId: $layerId) {
    success
    totalVotes
    hasVoted
  }
}
    `;
export type VoteForStubLayerMutationFn = Apollo.MutationFunction<VoteForStubLayerMutationPage, VoteForStubLayerMutationVariables>;

/**
 * __useVoteForStubLayerMutation__
 *
 * To run a mutation, you first call `useVoteForStubLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteForStubLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteForStubLayerMutation, { data, loading, error }] = useVoteForStubLayerMutation({
 *   variables: {
 *      layerId: // value for 'layerId'
 *   },
 * });
 */
export function useVoteForStubLayerMutation(baseOptions?: Apollo.MutationHookOptions<VoteForStubLayerMutationPage, VoteForStubLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteForStubLayerMutationPage, VoteForStubLayerMutationVariables>(VoteForStubLayerDocument, options);
      }
export type VoteForStubLayerMutationHookResult = ReturnType<typeof useVoteForStubLayerMutation>;
export type VoteForStubLayerMutationResult = Apollo.MutationResult<VoteForStubLayerMutationPage>;
export type VoteForStubLayerMutationOptions = Apollo.BaseMutationOptions<VoteForStubLayerMutationPage, VoteForStubLayerMutationVariables>;